import { Platform } from 'react-native';

global.REACT_APP_WORKFLOW = 'managed';
global.APP_VERSION = '1.0.0';
global.APP_BUILD_NUMBER = 1;
global.APP_KEY = 'designEngine';
global.IS_WEB = Platform.OS === 'web';
global.API_DOMAIN = window.location.href.includes('staging') ? 'https://symbolic-api-staging-1.herokuapp.com' : undefined;
